import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=6b4bdfac"
import script from "./Tags.ts?vue&type=script&lang=js&external"
export * from "./Tags.ts?vue&type=script&lang=js&external"
import style0 from "./VueMultiselectStyles.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports